import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { size, themeGet } from 'styled-system';
import { Flex, omitProps } from '@qga/roo-ui/components';

const DotNavigation = styled(Flex)`
  height: 20px;
  align-items: center;
  justify-content: center;
`;

const Dot = styled('div', omitProps(['isHighlighted']))`
  border-radius: ${themeGet('radii.rounded')};
  background-color: ${(props) => (props.isHighlighted ? themeGet('colors.greys.dusty') : themeGet('colors.greys.alto'))};
  display: inline-block;
  &:not(:last-child) {
    margin-right: ${themeGet('space.4')};
  }
  ${size};
`;

const HorizontalDotNavigation = ({ position, total, size }) => {
  return (
    <DotNavigation role="list" aria-label="Navigation dots">
      {Array.from({ length: total }, (_, dotPosition) => {
        const isHighlighted = dotPosition === position;
        return (
          <Dot
            key={`dot-${dotPosition}`}
            role="listitem"
            aria-current={isHighlighted ? 'true' : undefined}
            isHighlighted={isHighlighted}
            size={size}
          />
        );
      })}
    </DotNavigation>
  );
};

HorizontalDotNavigation.propTypes = {
  total: PropTypes.number,
  position: PropTypes.number,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

HorizontalDotNavigation.defaultProps = {
  total: 3,
  position: 1,
  size: 10,
};

export default HorizontalDotNavigation;
